const commalize = (amount) =>{
    if(isNaN(amount)) {
        return '';
    }
        const amt = amount.toString();
        const len = amt.length;
        switch (len) {
                case 4:
                return amt.substring(0, 1) + "," + amt.substring(1);
            case 5:
                return amt.substring(0, 2) + "," + amt.substring(2);
            case 6:
                return amt.substring(0, 1) + "," + amt.substring(1, 3) + "," + amt.substring(3);
            case 7:
                return amt.substring(0, 2) + "," + amt.substring(2, 4) + "," + amt.substring(4);
            case 8:
                return amt.substring(0, 1) + "," + amt.substring(1, 3) + "," + amt.substring(3, 5) + "," + amt.substring(5);
            case 9:
                return amt.substring(0, 2) + "," + amt.substring(2, 4) + "," + amt.substring(6, 4) + "," + amt.substring(6, 9);
            default:
                return amt;
        }
}

const searchRecord = (record, key, value) =>{
        const max = record.length;
        for (let i = 0; i < max; i++) {
            if(parseInt(record[i][key], 10) === parseInt(value, 10)){
                return record[i];
            }
        }
        return {};
}
/**
 * Return index, row after searching in records
 * @param {haystack} record array
 * @param {needleRef} key string
 * @param {needle} value integer
 */
const searchRecordIndex = (record, key, value) =>{
        const max = record.length;
        for (let i = 0; i < max; i++) {
            if(parseInt(record[i][key], 10) === parseInt(value, 10)){
                return {
                    index: i,
                    row: record[i]
                }
            }
        }
        return -1;
}

const isSameObject = (obj1, obj2) =>{
    const keys = Object.keys(obj1);
    const result = [];
    //NO OF KEYS ARE SAME
    if(keys.length === Object.keys(obj2).length){

        //CHECK IF EACH PROPERTY IS SAME
        keys.forEach(param => {
            if(obj1[param] === obj2[param]){
                result.push(1);
            } else {
                result.push(0);
            }
        });

        //COUNT HOW MANY PROPERTY ARE SAME
        let count = 0;
        result.forEach(status => {
            count += status
        })
        if(count === keys.length){
            //ALL PARAMETERS ARE SAME
            return true;
        }
    }
    return false;
}

const _Helper = {
        commalize,
        searchRecord,
        searchRecordIndex,
        isSameObject
}
export default _Helper;
